// The video backend's calls that new code makes (building-during-the-rebuild.md, "Backend calls in one small module
// per area"). The Create page's older video calls stay in generate/api.ts.
//
// `token` is the person's Firebase ID token, sent raw in Authorization as the video machines read it.

import { call, lazySide } from './doorway.ts'
import { isV2Media } from './media-ids.ts'

const VIDEO = process.env.NEXT_PUBLIC_PROMPTCHAN_VIDEO

/**
 * Joins the person's own clips, in order, into one unsaved video (flag extend_clips): `{ video, doc_ref }`, which
 * then saves, publishes and downloads like any other video. Answers 404 outside the flag, 422 `clips_mismatch` for
 * clips of different shapes, 422 `too_long` past the join's limit. With the `create_video` area on v2, or when any
 * clip is v2's (`isV2Media`, whatever the switch says: v1 can't find v2's clips), the join is v2's free `clip_join`
 * order (src/lib/api/video-v2.ts, `join`), v1's clips in it too, answered in the same shape; a story of v1's clips alone
 * that v2 can't read is joined by v1.
 */
export const joinClips = (token: string, clipIds: string[]) => {
  const url = `${VIDEO}/api/video_v3.1/clips/join`
  const init: RequestInit = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: token },
    body: JSON.stringify({ clip_ids: clipIds }),
  }
  return call('create_video', url, init, {
    token,
    ownedByV2: clipIds.some(isV2Media),
    side: lazySide(
      () => import('./video-v2.ts'),
      (loaded) => (t) => loaded.join(t, clipIds, () => fetch(url, init)),
      url,
    ),
  })
}
